export const Breakpoints = {
  tablet: '920px',
  mobile: '660px',
  smallMobile: '330px'
};
